import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {AssignmentsLink, ProgressTrackingLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const MonitoringAndStatisticsGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.monitoring_and_statistics',
    links: [
        AssignmentsLink(context),
        ProgressTrackingLink(context)
    ],
    icon: 'navigation-group__monitoring-and-statistics',
})

